__webpack_require__.p = "/react_simple_shop/";